/**
 * A light weight alternative to using moment.js
 *
 * No Dependencies
 */
const DateFormat = {

	daysOfWeek: [
		'Sunday',
		'Monday',
		'Tuesday',
		'Wednesday',
		'Thursday',
		'Friday',
		'Saturday',
	],

	months: [
		'January',
		'February',
		'March',
		'April',
		'May',
		'June',
		'July',
		'August',
		'September',
		'October',
		'November',
		'December',
	],

	format: function (date, format) {
		switch (format) {
			case 'dd-mm-yyyy':
				return [
					this.getDate(date, 'dd'),
					this.getMonth(date, 'mm'),
					this.getYear(date, 'yyyy'),
				].join('-');
			case 'yyyy-mm-dd':
				return [
					this.getYear(date, 'yyyy'),
					this.getMonth(date, 'mm'),
					this.getDate(date, 'dd'),
				].join('-');
			case 'd mmm yyyy':
				return [
					this.getDate(date, 'd'),
					this.getMonth(date, 'mmm'),
					this.getYear(date, 'yyyy')
				].join(' ');
		}
	},


	getYear: function (date, format) {
		if (format === 'yy') {
			return (date.getFullYear() + '').slice(2);
		} else {
			return date.getFullYear() + '';
		}
	},

	getMonth: function (date, format) {
		switch (format) {
			case 'm':
				return (date.getMonth() + 1) + '';
			case 'mm':
				return (date.getMonth() < 9) ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1) + '';
			case 'mmm':
				return this.months[date.getMonth()].slice(0, 3);
			case 'mmmm':
				return this.months[date.getMonth()];
			default:
				return this.months[date.getMonth()];
		}
	},

	getDate: function (date, format) {
		switch (format) {
			case 'd':
				return date.getDate() + '';
			case 'dd':
				return (date.getDate() < 10) ? '0' + date.getDate() : date.getDate() + '';
			case 'ddd':
				return this.daysOfWeek[date.getDay()].slice(0, 3);
			case 'dddd':
				return this.daysOfWeek[date.getDay()];
			default:
				return this.daysOfWeek[date.getDay()];
		}
	},

	nights: function (date1, date2) {
		const oneDay = 1000 * 60 * 60 * 24;
		return Math.floor((date1 - date2) / oneDay);
	},

	/**
	 *
	 * @param {Date} date
	 * @param {int} amount
	 * @param {string} unit
	 * @returns {Date}
	 */
	add: (date, amount, unit) => {
		const newDate = new Date(+date);
		switch (unit) {
			case 'month':
			case 'months':
				newDate.setMonth(newDate.getMonth() + amount);
				return newDate;
			case 'day':
			case 'days':
				newDate.setDate(newDate.getDate() + amount);
				return newDate;
			default:
				throw new Error(`Invalid unit: ${unit}`);
		}
	}

};

export default DateFormat;
